/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RichiesteCausaliCdlInsertDTO
 */
export interface RichiesteCausaliCdlInsertDTO {
    /**
     * 
     * @type {number}
     * @memberof RichiesteCausaliCdlInsertDTO
     */
    idPersonale?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlInsertDTO
     */
    idCausaleRichiesta?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlInsertDTO
     */
    dataA?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlInsertDTO
     */
    dataDa?: Date;
    /**
     * 
     * @type {string}
     * @memberof RichiesteCausaliCdlInsertDTO
     */
    note?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteCausaliCdlInsertDTO
     */
    oraInizio?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof RichiesteCausaliCdlInsertDTO
     */
    ore?: number | null;
}

/**
 * Check if a given object implements the RichiesteCausaliCdlInsertDTO interface.
 */
export function instanceOfRichiesteCausaliCdlInsertDTO(value: object): value is RichiesteCausaliCdlInsertDTO {
    return true;
}

export function RichiesteCausaliCdlInsertDTOFromJSON(json: any): RichiesteCausaliCdlInsertDTO {
    return RichiesteCausaliCdlInsertDTOFromJSONTyped(json, false);
}

export function RichiesteCausaliCdlInsertDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RichiesteCausaliCdlInsertDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'idCausaleRichiesta': json['idCausaleRichiesta'] == null ? undefined : json['idCausaleRichiesta'],
        'dataA': json['dataA'] == null ? undefined : (new Date(json['dataA'])),
        'dataDa': json['dataDa'] == null ? undefined : (new Date(json['dataDa'])),
        'note': json['note'] == null ? undefined : json['note'],
        'oraInizio': json['oraInizio'] == null ? undefined : (new Date(json['oraInizio'])),
        'ore': json['ore'] == null ? undefined : json['ore'],
    };
}

export function RichiesteCausaliCdlInsertDTOToJSON(json: any): RichiesteCausaliCdlInsertDTO {
    return RichiesteCausaliCdlInsertDTOToJSONTyped(json, false);
}

export function RichiesteCausaliCdlInsertDTOToJSONTyped(value?: RichiesteCausaliCdlInsertDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idPersonale': value['idPersonale'],
        'idCausaleRichiesta': value['idCausaleRichiesta'],
        'dataA': value['dataA'] == null ? undefined : ((value['dataA']).toISOString()),
        'dataDa': value['dataDa'] == null ? undefined : ((value['dataDa']).toISOString()),
        'note': value['note'],
        'oraInizio': value['oraInizio'] == null ? undefined : ((value['oraInizio'] as any).toISOString()),
        'ore': value['ore'],
    };
}

